export default "/assets/images/uk-union-jack-sm.jpg?64cadf6afb33f2dbb22b2080a15dee60";